import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const complianceHoldFlagPoliceAtom = createMutationAtomFactory(
  'trade.complianceHoldFlagPolice',
  (params: { id: string; notes: string }) => ({
    tradeComplianceHoldFlagPolice: {
      __args: {
        id: params.id,
        input: {
          notes: params.notes,
        },
      },
      id: true,
      status: true,
    },
  }),
);
